"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var FormControl_1 = require("@material-ui/core/FormControl");
var Input_1 = require("@material-ui/core/Input");
var InputLabel_1 = require("@material-ui/core/InputLabel");
var InputAdornment_1 = require("@material-ui/core/InputAdornment");
var react_text_mask_1 = require("react-text-mask");
var Theme_1 = require("./Theme");
exports.default = (function (props) { return (React.createElement(Theme_1.default, { color: props.color || "primary" },
    React.createElement(reactstrap_1.FormGroup, { className: "".concat(props.className, " mui-input-text-group").concat(props.disabled ? " disabled" : "") },
        React.createElement(FormControl_1.default, { style: props.style || { width: "100%" } },
            React.createElement(InputLabel_1.default, { htmlFor: props.id, shrink: props.shrinkLabel }, props.label),
            React.createElement(Input_1.default, { id: props.id, defaultValue: props.defaultValue, value: props.value, onChange: props.onChange, onBlur: props.onBlur, type: props.type, multiline: props.multiline, rows: props.rows, endAdornment: props.postfix && React.createElement(InputAdornment_1.default, { position: "end" }, props.postfix), startAdornment: props.prefix && React.createElement(InputAdornment_1.default, { position: "start" }, props.prefix), disabled: props.disabled, inputComponent: props.mask
                    ? function (_a) {
                        var inputRef = _a.inputRef, other = __rest(_a, ["inputRef"]);
                        return (React.createElement(react_text_mask_1.default, __assign({}, other, { ref: inputRef, placeholderChar: "\u0020", showMask: true, mask: props.mask, guide: false })));
                    }
                    : undefined }))))); });
//# sourceMappingURL=FormControlTextField.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/FormControlTextField.js
// module id = 2221
// module chunks = 0